"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fireEvent = exports.isInWebView = void 0;
const webview_1 = require("../types/webview");
function isInWebView() {
    var _a, _b;
    return (Boolean(window === null || window === void 0 ? void 0 : window.ReactNativeWebView) ||
        ((_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes('Grover')));
}
exports.isInWebView = isInWebView;
function fireEvent(name, args) {
    (window.InWebViewAPI =
        window.InWebViewAPI || []).push([
        webview_1.WebViewEventType.fire,
        name,
        args,
    ]);
}
exports.fireEvent = fireEvent;
//# sourceMappingURL=webview.js.map